<template>
<div class="chapter">
<div class="inner_page">
<div class="fb-title">CONTENTS</div>
<div class="toc1" style="margin-top:0em;"><a href="#/ack#toc1a" id="toc1">Acknowledgments</a></div>
<div class="toc0" style="margin-top:1.5em;"><a href="#/introduction#toc2a" id="toc2">Introduction</a></div>
<div class="toc0"><span href="#/ch01#toc3a" id="toc3" title="Link target outside of Sample"><span class="small">ONE</span> / Alibi: Portrait of a Con Man</span></div>
<div class="toc0"><span href="#/ch02#toc4a" id="toc4" title="Link target outside of Sample"><span class="small">TWO</span> / City Cons and Hustles</span></div>
<div class="toc0"><span href="#/ch03#toc5a" id="toc5" title="Link target outside of Sample"><span class="small">THREE</span> / The Con Crew</span></div>
<div class="toc0"><span href="#/ch04#toc6a" id="toc6" title="Link target outside of Sample"><span class="small">FOUR</span> / The Con Game as Street Theater</span></div>
<div class="toc0"><span href="#/ch05#toc7a" id="toc7" title="Link target outside of Sample"><span class="small">FIVE</span> / Petty Street Hustles</span></div>
<div class="toc0"><span href="#/ch06#toc8a" id="toc8" title="Link target outside of Sample"><span class="small">SIX</span> / Canal Street as Venus Flytrap</span></div>
<div class="toc0"><span href="#/ch07#toc9a" id="toc9" title="Link target outside of Sample"><span class="small">SEVEN</span> / The Numbers Game</span></div>
<div class="toc0"><span href="#/ch08#toc10a" id="toc10" title="Link target outside of Sample"><span class="small">EIGHT</span> / New York Tenant Hustles</span></div>
<div class="toc0"><span href="#/ch09#toc11a" id="toc11" title="Link target outside of Sample"><span class="small">NINE</span> / A Drug Hustle: The Crack Game</span></div>
<div class="toc0"><span href="#/ch10#toc12a" id="toc12" title="Link target outside of Sample"><span class="small">TEN</span> / NYPD and the Finest Cons</span></div>
<div class="toc0"><span href="#/ch11#toc13a" id="toc13" title="Link target outside of Sample"><span class="small">ELEVEN</span> / Wall Street Cons</span></div>
<div class="toc0"><span href="#/epilogue#toc14a" id="toc14" title="Link target outside of Sample">Epilogue</span></div>
<div> </div>
<div class="toc1"><span href="#/notes#toc15a" id="toc15" title="Link target outside of Sample">Notes</span></div>
<div> </div>
<div class="toc1"><span href="#/glossary#toc16a" id="toc16" title="Link target outside of Sample">Glossary</span></div>
<div> </div>
<div class="toc1"><span href="#/bibliography#toc17a" id="toc17" title="Link target outside of Sample">Bibliography</span></div>
<div> </div>
<div class="toc1"><span href="#/index#toc18a" id="toc18" title="Link target outside of Sample">Index</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?03f756d9